
export const normalizarBusca = (value) =>
  String(value ?? "")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase();

const semZerosEsquerda = (valor) => valor.replace(/^0+(?=\d)/, "");

const campoCasa = (campo, termo, termoSemZeros) => {
  const valor = normalizarBusca(campo);
  if (!valor) return false;
  if (valor.includes(termo)) return true;
  return termoSemZeros !== null && semZerosEsquerda(valor).includes(termoSemZeros);
};

const casaAlgum = (campos, termo, termoSemZeros) =>
  campos.some((campo) => campoCasa(campo, termo, termoSemZeros));

export const clienteMatches = (cliente, termo, termoSemZeros = null) => {
  if (!termo) return true;
  return casaAlgum(
    [cliente?.nome, cliente?.codigoCliente, cliente?.id, cliente?.grupoCentralizador],
    termo,
    termoSemZeros,
  );
};

export const vendedorMatches = (linha, termo, termoSemZeros = null) => {
  if (!termo) return true;
  return casaAlgum([linha?.vendedor, linha?.codigoVendedor], termo, termoSemZeros);
};

export const filtrarLinhas = (linhas, termoBruto) => {
  const termo = normalizarBusca(termoBruto).trim();
  if (!termo) return linhas ?? [];

  const termoSemZeros = /^\d+$/.test(termo) ? semZerosEsquerda(termo) : null;

  return (linhas ?? []).reduce((acc, row) => {
    if (vendedorMatches(row, termo, termoSemZeros)) {
      acc.push(row);
      return acc;
    }
    const clientes = (row.clientes ?? []).filter((c) => clienteMatches(c, termo, termoSemZeros));
    if (clientes.length) acc.push({ ...row, clientes });
    return acc;
  }, []);
};
